import React, {useEffect, useState} from 'react'
import {useFormContext} from "react-hook-form";
import { AsyncCreatableSelect as AsyncCreatable, AsyncSelect } from '@atlaskit/select';
import Spinner from '@atlaskit/spinner';

import {get, post} from "../../services/ApiService";

const LoadingIndicator = (props) => {
    return <Spinner {...props} />;
};

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        padding: '0',
        margin: '0',
        borderColor: '#ced4da',
        backgroundColor: '#FFF',
        boxShadow: 'none',
        fontSize: '12px',
        minHeight: '30px',
        height: '30px',
        '&:hover': {
            borderColor: '#ced4da',
        },
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0',
        margin: '0',
    }),
    input: (provided) => ({
        ...provided,
        padding: '0',
        margin: '0',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        margin: '0',
        padding: '0',
        height: '28px',
    }),
};

const useData = (router, idField, titleField, extraDataOnFilter) => {
    const [isLoading, setIsLoading] = useState(false);

    const transformDataToSelect = (item) => {
        return {
            label: item[titleField],
            value: item[idField],
        }
    }

    const fetchOptions = (filterValue) => {
        const filters = [
            filterValue ? { name: titleField, v: filterValue, v2: null, op: 'like' } : null,
            extraDataOnFilter || null
        ].filter(Boolean);

        const filterParam = encodeURIComponent(JSON.stringify(filters));

        return get(`/?route=${router}/grid&action=list&skip=0&limit=20&filterValue=${filterParam}`)
            .then((response) => {
                return (response.data?.rows || []).map(transformDataToSelect);
            })
            .catch(() => [])
            .finally(() => setIsLoading(false));
    };

    const createOption = (data) => {
        return post(`/?route=${router}/form&action=add`, {dados: data})
            .then((response) => {
                if (response.status === 200 && response.data.success) {
                    return transformDataToSelect(response.data.model);
                }
                return Promise.reject(response.data?.message || 'Falha ao salvar');
            })
            .finally(() => setIsLoading(false));
    }

    return [fetchOptions, createOption, isLoading, setIsLoading];
};

export default function UiSelectPicker({ label, name, size, idField, titleField, extraDataOnCreate, extraDataOnFilter, router, allowCreate = true, ...rest }){
    const { register, setValue, watch } = useFormContext();
    const value = watch(name);
    const [fetchOptions, createOption, isLoading, setIsLoading] = useData(router, idField, titleField, extraDataOnFilter);

    const handleCreateOption = (inputValue) => {
        setIsLoading(true);
        createOption({
            [titleField]: inputValue,
            ...extraDataOnCreate
        }).then((newOption) => {
            setValue(name, [...(value || []), newOption]);
        }).catch((err) => {
            console.error(err);
        });
    };

    useEffect(() => {
        register(name);
    }, [register]);

    const SelectComponent = allowCreate ? AsyncCreatable : AsyncSelect;

    return (
        <div className={`col-lg-${(size) ? size : 12}`}>
            <div className="form-item">
                <label className="form-label">{label}</label>
                <div className="field-container">
                    <SelectComponent
                        isMulti
                        loadOptions={fetchOptions}
                        defaultOptions={true}
                        cacheOptions
                        {...(allowCreate ? {
                            allowCreateWhileLoading: false,
                            onCreateOption: handleCreateOption
                        } : {})}
                        placeholder="Pesquisar"
                        loadingMessage={() => <>Carregando</> }
                        noOptionsMessage={() => <>Nenhuma opção</> }
                        styles={customStyles}
                        value={value}
                        components={{ LoadingIndicator }}
                        onChange={(newValue) => {
                            setValue(name, newValue);
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
